import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {Paginator} from 'front-onceforall-core';
import Organisation from './organisation';

function InvalidOrganisationDocumentsView(props) {
  function getIntervention(interventionId) {
    return interventionId ?
      props.interventions.find(intervention => intervention.interventionId === interventionId) :
      undefined;
  }

  return (
    <div>
      {props.title &&
        <div className="font-size-xl mb-4">
          <strong>{props.title}</strong>
        </div>
      }
      <div>
        {props.loading && <div className="loading-overlay"/>}
        {props.organisations.length === 0 ?
          <div className="card table-without-result">
            <Translate value="invalidOrganisationDocuments.emptyMessage"/>
          </div> :
          <div>
            {props.organisations.map((organisation, index) => (
              <Organisation
                key={index}
                organisation={organisation}
                intervention={getIntervention(organisation.interventionId)}
                country={props.country}
              />
            ))}
            <div className="mt-2 mb-4">
              <Paginator
                totalItems={props.totalCount}
                pageSize={props.pageSize}
                currentPage={props.pageNumber}
                onChangePage={props.onPageChange}
              />
            </div>
          </div>
        }
      </div>
    </div>
  );
}

InvalidOrganisationDocumentsView.propTypes = {
  loading: PropTypes.bool.isRequired,
  organisations: PropTypes.array.isRequired,
  totalCount: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  pageNumber: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  country: PropTypes.string,
  interventions: PropTypes.array,
  title: PropTypes.element
};

export default InvalidOrganisationDocumentsView;
